import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import WalletConnectProvider from '@walletconnect/web3-provider';
import abi from '../abi.json';  // Ensure your ABI file path is correct
import './MintComponent.css';   // Ensure you have the CSS for any additional styling

const MintComponent = () => {
  const [web3, setWeb3] = useState(null);
  const [account, setAccount] = useState(null);
  const [contract, setContract] = useState(null);

  const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
  const infuraId = process.env.REACT_APP_INFURA_ID;

  useEffect(() => {
    if (web3 && account) {
      const mintContract = new web3.eth.Contract(abi, contractAddress);
      setContract(mintContract);
    }
  }, [web3, account]);

  const connectMetaMask = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const web3Instance = new Web3(window.ethereum);
        const accounts = await web3Instance.eth.getAccounts();
        setWeb3(web3Instance);
        setAccount(accounts[0]);
      } catch (error) {
        console.error("MetaMask connection error:", error);
      }
    } else {
      console.error("MetaMask is not installed!");
    }
  };

  const connectWalletConnect = async () => {
    try {
      const provider = new WalletConnectProvider({
        infuraId: infuraId, // Use the environment variable for Infura ID
      });

      await provider.enable();
      const web3Instance = new Web3(provider);
      const accounts = await web3Instance.eth.getAccounts();
      setWeb3(web3Instance);
      setAccount(accounts[0]);
    } catch (error) {
      console.error("WalletConnect connection error:", error);
    }
  };

  const mintMultipleTokens = async () => {
    if (!contract || !account) {
      console.error("Contract not loaded or wallet not connected!");
      return;
    }

    try {
      console.log("Attempting to mint a token...");

      const response = await contract.methods.mintMultiple(1).send({
        from: account,
        value: 0,
        gas: 300000,
      });

      console.log("Minting successful:", response);

    } catch (error) {
      console.error("Error executing transaction:", error);

      if (error.message.includes("User denied")) {
        console.log("The transaction was rejected by the user.");
      }
    }
  };

  return (
    <div className="mint-buttons">
      {account ? (
        <p>Connected as: {account}</p>
      ) : (
        <>
          <button onClick={connectMetaMask} className="mint-button">Connect MetaMask</button>
          <button onClick={connectWalletConnect} className="mint-button">Connect WalletConnect</button>
        </>
      )}
      {contract && (
        <button onClick={mintMultipleTokens} className="mint-button">Mint Tokens</button>
      )}
    </div>
  );
};

export default MintComponent;